import {
    audioMessages as audioMessagesState,
    clearHistoryMessagesInfo,
    clearRoomMessages as clearRoomMessagesState,
    closeNotifyMessages,
    deleteMessages,
    insertMessages,
    notifyMessages,
    receiveMessages as receiveMessagesState,
    setRoomMessages as setRoomMessagesState,
    setSendMsg as setSendMsgState,
    updateHistoryMessages,
    updateMessages,
} from "@/store/reducers/messages";
import {
    setRoomInitialized,
    updateRoomLastMessage as updateRoomLastMessageState,
} from "@/store/reducers/room";
import {
    MESSAGE_PAGE_SIZE,
    deleteLocalMessage,
    enqueueSaveRoomMessages,
    getLocalRoomMessagePage,
    initializeRoomMessages,
    saveRoomMessagePage,
} from "@/utils/db/indexedDB";
import { normalizeMessages } from "@/utils/common";
import useJwt from "@/utils/jwt/useJwt";

const handleSaveIndexDB = (messages) => {
    if (!messages?.length) return;

    const room_id = messages[0].room_id;

    enqueueSaveRoomMessages(
        useJwt.getUserID(),
        room_id,
        messages
    );
};

// ** Get messages
export const getMessages = (payload) => {
    return async (dispatch) => {
        try {
            const limit = payload.limit || MESSAGE_PAGE_SIZE;
            const res = await useJwt.getMessages({
                ...payload,
                limit,
            });

            if (res.data.ResponseCode === 0) {
                const data = normalizeMessages(res.data.ResponseResult);

                dispatch(setRoomMessagesState({
                    room_id: payload.id,
                    messages: data.slice(-limit)
                }));
                dispatch(setRoomInitialized({
                    room_id: payload.id,
                    status: true
                }));

                await initializeRoomMessages(useJwt.getUserID(), payload.id, data, {
                    limit,
                    isComplete: data.length < limit,
                });

                return data;
            }

            console.log(res.data.ResponseCode);
            return [];
        } catch (err) {
            console.log(err);
            return [];
        }
    };
};

// ** Get last messages
export const getLastMessages = (payload) => {
    return async (dispatch) => {
        try {
            const limit = payload.limit || MESSAGE_PAGE_SIZE;
            const userId = useJwt.getUserID();
            const cached = await getLocalRoomMessagePage(
                userId,
                payload.id,
                payload.last_message_id,
                limit
            );

            if (cached) {
                dispatch(updateMessages(cached.messages));
                return cached.messages;
            }

            const res = await useJwt.getMessages({
                ...payload,
                limit,
            });

            if (res.data.ResponseCode === 0) {
                const data = normalizeMessages(res.data.ResponseResult);
                dispatch(updateMessages(data));

                await saveRoomMessagePage(userId, payload.id, data, {
                    cursorId: payload.last_message_id,
                    limit,
                    isComplete: data.length < limit,
                });

                return data;
            }

            return [];
        } catch (err) {
            console.log(err);
            return [];
        }
    };
};

export const reduxInsertMessages = (messages) => {
    return (dispatch) => {
        const normalizedMessages = normalizeMessages(messages);
        if (!normalizedMessages.length) return;

        handleSaveIndexDB(normalizedMessages);

        console.log("Inserting messages into Redux store:", normalizedMessages);

        dispatch(insertMessages(normalizedMessages));
    };
};

export const reduxUpdateMessages = (messages) => {
    return (dispatch) => {
        const normalizedMessages = normalizeMessages(messages);
        if (!normalizedMessages.length) return;

        handleSaveIndexDB(normalizedMessages);
        console.log("UPDATE_MESSAGES into Redux store:", normalizedMessages);

        dispatch(updateMessages(normalizedMessages));
    };
};

export const reduxDeleteMessages = (message_ids) => {
    return (dispatch, getState) => {
        if (!message_ids?.length) return;

        const state = getState();
        const messages = state.messages.messages;
        const idSet = new Set(message_ids);
        let targetRoomId = null;
        let roomMessages = [];

        for (const [roomId, msgs] of Object.entries(messages)) {
            if (msgs.some((message) => idSet.has(message.id))) {
                targetRoomId = Number(roomId);
                roomMessages = msgs;
                break;
            }
        }

        if (targetRoomId === null) {
            dispatch(deleteMessages(message_ids));
            return;
        }

        const newMsgs = roomMessages
            .filter((message) => !idSet.has(message.id))
            .sort((a, b) => b.created_at - a.created_at);
        const lastMsg = newMsgs[0] || null;

        deleteLocalMessage(
            useJwt.getUserID(),
            targetRoomId,
            message_ids
        );

        dispatch(deleteMessages(message_ids));

        dispatch(updateRoomLastMessageState({
            room_id: targetRoomId,
            last_message: lastMsg
        }));
    };
};

export const updateHistryMessages = (messagesInfo) => updateHistoryMessages(messagesInfo);

export const clearHistryMessagesInfo = () => clearHistoryMessagesInfo();

export const setRoomMessages = (payload) => setRoomMessagesState(payload);

export const clearRoomMessages = (room_id) => clearRoomMessagesState(room_id);

export const receiveMessages = () => receiveMessagesState();

export const audioMessages = () => audioMessagesState();

export const notifyMessage = (data) => notifyMessages(data);

export const closeNotifyMessage = () => closeNotifyMessages();

export const setSendMsg = (data) => setSendMsgState(data);
